// eslint-disable--next-line import/no-unresolved
import '@ungap/global-this/index';
import { extraConfig } from '@upflowy/firebaseconfig';
import { FirebaseAppProvider, FirestoreProvider, initFirebase } from '@upflowy/firestore';
import { getFirestore } from 'firebase/firestore';
import 'proxy-polyfill';
import React, { ReactNode } from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';

import App from './App';
import config from './helpers/config';
import './index.css';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.info('packages/consumer | process.env', process.env);
  // eslint-disable-next-line no-console
  console.info('packages/consumer | config', config);
}

initFirebase(extraConfig);

function ConsumerFirestoreProvider({ children }: { children: ReactNode }) {
  const firestore = getFirestore();
  return <FirestoreProvider sdk={firestore}>{children}</FirestoreProvider>;
}

// TODO loading
ReactDOM.render(
  <FirebaseAppProvider firebaseConfig={config.dbConfig}>
    <ConsumerFirestoreProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ConsumerFirestoreProvider>
  </FirebaseAppProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
